// src/pages/ChoixAssociation.js
// Dernière étape d'un compte créé avec Google (ou d'une inscription interrompue) :
// prénom + nom de l'association, puis création de l'association.
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

function lireSession(cle) {
  try { return sessionStorage.getItem(cle) || ""; } catch { return ""; }
}

export default function ChoixAssociation() {
  const { currentUser, profil, finaliserCompte, deconnecter } = useAuth();
  const prenomGoogle = (currentUser?.displayName || "").trim().split(/\s+/)[0] || "";
  const [pseudo, setPseudo] = useState(profil?.pseudo || prenomGoogle);
  const [nomAsso, setNomAsso] = useState(lireSession("tl_nomAsso"));
  const [cgv, setCgv] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!nomAsso.trim()) { setError("Indiquez le nom de votre association ou de votre club."); return; }
    if (!cgv) { setError("Vous devez accepter les CGV pour continuer."); return; }
    setLoading(true); setError("");
    try {
      await finaliserCompte({ nomOrganisation: nomAsso, pseudo });
      try { sessionStorage.removeItem("tl_nomAsso"); } catch { /* rien */ }
    } catch (err) {
      console.error("finaliserCompte:", err?.code || err?.message);
      setError("Erreur lors de la création de l'association. Réessayez.");
      setLoading(false);
    }
  }

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.header}>
          <img src="/logo_app.png" alt="TomboLive" style={s.logoImg} />
          <h1 style={s.title}>Bienvenue{pseudo ? ` ${pseudo}` : ""} ! 👋</h1>
          <p style={s.subtitle}>Dernière étape : pour quelle association organisez-vous votre tombola ?</p>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>🏢 Nom de l'association ou du club *</label>
            <input type="text" placeholder="Ex : Comité des fêtes de Desnes"
              value={nomAsso} onChange={(e) => { setNomAsso(e.target.value); setError(""); }}
              maxLength={120} style={s.input} required autoFocus />
          </div>

          <div style={s.field}>
            <label style={s.label}>👤 Votre prénom</label>
            <input type="text" placeholder="Ex : Arnaud"
              value={pseudo} onChange={(e) => setPseudo(e.target.value)}
              maxLength={60} style={s.input} />
          </div>

          <div style={s.compte}>Compte : <strong>{currentUser?.email}</strong></div>

          <label style={s.cgvLabel}>
            <input type="checkbox" checked={cgv}
              onChange={(e) => { setCgv(e.target.checked); setError(""); }}
              style={{ marginRight: "8px" }} />
            <span>
              J'accepte les{" "}
              <a href="https://tombo.live/cgv/" target="_blank" rel="noopener noreferrer" style={s.cgvLink}>Conditions Générales de Vente</a>
              {" "}et la{" "}
              <a href="https://tombo.live/confidentialite/" target="_blank" rel="noopener noreferrer" style={s.cgvLink}>Politique de confidentialité</a>
            </span>
          </label>

          {error && <div style={s.errBox}>⚠️ {error}</div>}

          <button type="submit" disabled={loading} style={s.btnPrimary}>
            {loading ? "Création…" : "🚀 Créer mon association"}
          </button>
        </form>

        <button type="button" onClick={deconnecter} style={s.linkBtn}>
          Ce n'est pas le bon compte ? Se déconnecter
        </button>
      </div>
    </div>
  );
}

const s = {
  wrapper: { minHeight:"100vh", background:"linear-gradient(135deg,#1a3a8f,#764ba2)", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem 1rem" },
  card: { background:"#fff", borderRadius:"20px", width:"100%", maxWidth:"420px", padding:"2rem", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" },
  header: { textAlign:"center", marginBottom:"1.5rem" },
  logoImg: { width:"96px", height:"96px", objectFit:"contain", marginBottom:"0.5rem" },
  title: { fontSize:"1.4rem", fontWeight:"800", color:"#1a1a2e", marginBottom:"0.35rem" },
  subtitle: { fontSize:"0.88rem", color:"#777", lineHeight:1.5 },
  form: { display:"flex", flexDirection:"column", gap:"1rem" },
  field: { display:"flex", flexDirection:"column", gap:"6px" },
  label: { fontSize:"0.85rem", fontWeight:"600", color:"#444" },
  input: { padding:"0.7rem 1rem", border:"1.5px solid #e0e0e0", borderRadius:"10px", fontSize:"0.95rem", outline:"none", width:"100%", boxSizing:"border-box" },
  compte: { fontSize:"0.8rem", color:"#888", background:"#f7f8fc", borderRadius:"8px", padding:"0.55rem 0.8rem", wordBreak:"break-all" },
  cgvLabel: { display:"flex", alignItems:"flex-start", fontSize:"0.82rem", color:"#555", lineHeight:1.5, cursor:"pointer" },
  cgvLink: { color:"#667eea", textDecoration:"none", fontWeight:"600" },
  errBox: { background:"#ffebee", color:"#b71c1c", borderRadius:"10px", padding:"0.75rem 1rem", fontSize:"0.85rem" },
  btnPrimary: { padding:"0.9rem", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"12px", fontSize:"1rem", fontWeight:"800", cursor:"pointer" },
  linkBtn: { display:"block", margin:"1.25rem auto 0", background:"none", border:"none", color:"#888", fontSize:"0.8rem", cursor:"pointer", textDecoration:"underline" },
};
